export const homePage = {
    footerText: 'דרושים IL לוח דרושים מספר 1 בישראל',

    SectionCompaniesInnerPages: {
        titleAll: 'חברות  מובילות באתר',
        titleHitech: 'חברות הייטק מובילות באתר',
        generalDFP: '3177829/if-drushim-left',
        hitechDFP: '3177829/drushim-hitech-',
    },

    SectionCompanies: {
        text1: 'החברות הגדולות',
        text2: 'מחפשות אותך'
    }
}